import { MathUtils, Path, Shape } from "three";
import {
	type ThreeInputLinesType,
	ThreeShapeSideTypes,
	type ThreeSidePathsType,
} from "../../../../../types/three";
import type { DimensionProperties } from "../../../../../types/workpiece";
import Oval from "../Oval";

export default class RegularOval extends Oval {
	public static code = "plate_oval_regular";

	protected calculateOutlineLength(length: number, width: number): number {
		const a: number = length / 2;
		const b: number = width / 2;

		const h: number = (a - b) ** 2 / (a + b) ** 2;

		return Math.PI * (a + b) * (1 + (3 * h) / (10 + Math.sqrt(4 - 3 * h)));
	}

	public getThreeShape(props: DimensionProperties["plate_oval_regular"]) {
		const [length, width] = [props.length / 1000, props.width / 1000];

		const s = new Shape();
		s.moveTo(0, 0);
		s.ellipse(0, 0, length / 2, width / 2, 0, Math.PI * 2, true, 0);
		return s;
	}

	public getThreeSidePaths(props: DimensionProperties["plate_oval_regular"]): ThreeSidePathsType[] {
		const [length, width] = [props.length / 1000, props.width / 1000];

		return [
			{
				path: new Path()
					.moveTo(length / 2, width / 2)
					.ellipse(
						0,
						0,
						length / 2,
						width / 2,
						MathUtils.degToRad(0),
						MathUtils.degToRad(360),
						true,
						0,
					),
				type: ThreeShapeSideTypes.side,
				code: "length1",
			},
		];
	}

	public getThreeInputLines(
		props: DimensionProperties["plate_oval_regular"],
	): ThreeInputLinesType[] {
		const [length, width] = [props.length / 1000, props.width / 1000];

		return [
			{
				dimension: props.length,
				path: new Path().moveTo(0, 0).lineTo(length, 0),
				type: ThreeShapeSideTypes.side,
				code: "length",
			},
			{
				dimension: props.width,
				path: new Path().moveTo(0, 0).lineTo(0, width),
				type: ThreeShapeSideTypes.side,
				code: "width",
			},
		];
	}

	public getDimensions(props: DimensionProperties["plate_oval_regular"]) {
		return {
			length: props.length ? props.length : 2000,
			width: props.width ? props.width : 1000,
		};
	}
}
